export class BAOBreadcrumbs extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.setCollectionCrumbText()
  }

  setCollectionCrumbText () {
    const referrer = document.referrer
    const referrerIsCollection = referrer.includes('/collections/')

    if (!referrerIsCollection) return

    const stripParams = referrer.split('?')[0]
    const urlParts = stripParams.split('/')

    const collectionName = urlParts[urlParts.length - 1]
    const collectionNameCapitalised = this.captitaliseName(collectionName)

    this.els.collectionCrumb.element.setAttribute('aria-hidden', 'false')
    this.els.collectionCrumbText.element.innerText = collectionNameCapitalised
    this.els.collectionCrumbLink.element.href = stripParams
  }

  captitaliseName (str) {
    let capitalised = this.capitalise(str)

    if (str.includes('-')) {
      const parts = str.split('-')
      const capitalisedParts = parts.map(part => this.capitalise(part))

      capitalised = capitalisedParts.join(' ')
    }

    return capitalised
  }

  capitalise (str) {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
  }
}

if (!customElements.get('bao-breadcrumbs')) {
  customElements.define('bao-breadcrumbs', BAOBreadcrumbs)
}
